import { render, staticRenderFns } from "./vehicleslist.vue?vue&type=template&id=38bf66bf&scoped=true"
import script from "./vehicleslist.js?vue&type=script&lang=js&external"
export * from "./vehicleslist.js?vue&type=script&lang=js&external"
import style0 from "./vehicleslist.vue?vue&type=style&index=0&id=38bf66bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf66bf",
  null
  
)

export default component.exports